/* unplugin-vue-components disabled */import { render } from "./AISpeachGenerator.vue?vue&type=template&id=25dc8948&scoped=true&ts=true"
import script from "./AISpeachGenerator.vue?vue&type=script&lang=ts"
export * from "./AISpeachGenerator.vue?vue&type=script&lang=ts"

import "./AISpeachGenerator.vue?vue&type=style&index=0&id=25dc8948&lang=scss"
import "./AISpeachGenerator.vue?vue&type=style&index=1&id=25dc8948&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dc8948"]])

export default __exports__